/** Front-end runtime config from VITE_* env vars (see repo-root .env.example). */
export const env = {
  useMockAuth: (import.meta.env.VITE_USE_MOCK_AUTH ?? 'true') !== 'false',
  mockRole: (import.meta.env.VITE_MOCK_ROLE ?? 'student') as 'student' | 'instructor',
  apiBase: import.meta.env.VITE_API_BASE ?? '/api',
  entra: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? '',
    authority: import.meta.env.VITE_ENTRA_AUTHORITY ?? '',
    knownAuthority: import.meta.env.VITE_ENTRA_KNOWN_AUTHORITY ?? '',
    // Always return to the domain the user is on (SWA default host or the
    // custom domain). Every origin used must be registered as a SPA redirect
    // URI on the Entra app registration.
    redirectUri: window.location.origin,
    apiScope: import.meta.env.VITE_API_SCOPE ?? '',
  },
};
